import type {MouseEvent, ReactElement} from 'react';
import {useState} from 'react';
import DialogBase from '@components/Dialog/DialogBase';
import {Trans} from '@lingui/macro';
import PrimaryButton from '@components/Button/PrimaryButton/PrimaryButton';
import useMutationWithAuth from '@hooks/useMutationWithAuth';
import {setOnboarded} from '@api/user';
import config from '@config/index';
import confetti from '@assets/images/confetti.svg';
import styles from './onboardingPopup.module.scss';

interface Props {
    isActive: boolean;
}

export default function OnboardingPopup(props: Props): ReactElement<Props> {
    const [isOpen, setIsOpen] = useState(props.isActive);
    const mutation = useMutationWithAuth({mutationFn: setOnboarded});

    function handleClose() {
        setIsOpen(false);
        mutation.mutate();
    }

    function stopPropagation(event: MouseEvent<HTMLDivElement>) {
        event.stopPropagation();
    }

    return (
        <DialogBase onClose={handleClose} isOpen={isOpen} isCentered>
            <div className={styles.body} onClick={stopPropagation}>
                <img className={styles.image} src={confetti} />
                <div className={styles.text}>
                    <Trans>
                        Congratulations!
                        <br />
                        You have {config.startingBalance} free feedback pages
                        as&nbsp;a&nbsp;gift&nbsp;🎁
                    </Trans>
                </div>
                <PrimaryButton onClick={handleClose}>
                    <Trans>let’s go!</Trans>
                </PrimaryButton>
            </div>
        </DialogBase>
    );
}

OnboardingPopup.defaultProps = {
    isActive: false,
};
